/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useRef } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { taskSimpleSelectors } from '../../../../../../../../app/resource/task-simple/task-simple.selectors';
import {
  clearTaskModalStatuses,
  storeTaskModalStatus,
} from '../../../../../../../../app/task-modals/task-modals.actions';
import { taskModalSelectors } from '../../../../../../../../app/task-modals/task-modals.selectors';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { LabelMenu } from '../../TaskMenus/LabelMenu';
import { ITaskLabelsProps } from './types';
import { initialBoardsForMeeting } from '../../../../../../../../app/page/home/home.actions';
import { labelSelectors } from '../../../../../../../../app/resource/label/label.selectors';

export const TaskLabels: FunctionComponent<ITaskLabelsProps> = ({ taskId }) => {
  const dispatch = useDispatch();
  const triggerRef = useRef<HTMLAnchorElement>(null);

  const open = useSelectWithParams(taskModalSelectors.selectTaskModalStatus, 'taskLabels');

  const toggle = useCallback(() => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    } else {
      dispatch(storeTaskModalStatus('taskLabels'));
    }
  }, [dispatch, open]);

  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId ?? '');
  // Fetch the label resources corresponding to task.labels
  const labels = useSelectWithParams(labelSelectors.selectResourcesById, task?.labels || []);

  useEffect(() => {
    if (task) {
      task.meetingIds.map((mt) => dispatch(initialBoardsForMeeting(mt)));
    }
  }, [dispatch, task]);

  return (
    <div className="col">
      <h5 className="bold">LABELS</h5>
      <div className="users py-1 flex aic">
        {labels &&
          labels.map(
            (label) =>
              label && (
                <a
                  className={`small-label mr-05`}
                  style={{ backgroundColor: `${label.color}` }}
                  key={`labelId-${label.id}`}
                ></a>
              ),
          )}

        <div className={open ? 'dropdown opened' : 'dropdown'}>
          <a
            className="small-label gray-bg blueGray bold mr-05 flex aic jcc dropdown-button"
            onClick={toggle}
            ref={triggerRef}
          >
            <i className="icon-plus" />
          </a>
          {open && <LabelMenu dropRight={false} closeMenu={toggle} taskId={taskId} triggerRef={triggerRef} />}
        </div>
      </div>
    </div>
  );
};
